import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signIn(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-5 grain" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="h-14 w-14 rounded-2xl bg-gold flex items-center justify-center mx-auto mb-4">
            <ShieldCheck className="h-7 w-7 text-navy" />
          </div>
          <h1 className="font-display text-2xl font-semibold text-white">Admin Login</h1>
          <p className="text-slate-400 text-sm mt-1">Girish Kumar Naidu — Public Service Platform</p>
        </div>
        <form onSubmit={submit} className="glass-dark rounded-2xl p-7 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-medium text-slate-200 mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white outline-none focus:border-gold" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-200 mb-2">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white outline-none focus:border-gold" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 px-5 py-3.5 rounded-xl bg-gold text-navy font-semibold hover:bg-gold-light transition-colors disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
